<!-- Spacer -->
<div
    class="devstroupe-horizontal-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
